/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Stack, Paper, Typography, Divider, Grid, Box } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Formik } from "formik";
import get from "lodash/get";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";

import Switch from "../../../components/form/Switch";
import InputText from "../../../components/form/InputText";
import Notification from "../../../components/form/Notification";
import Alert from "../../../components/form/Alert";
import Skeleton from "../../../components/form/Skeleton";
import Autocomplete from "../../../components/form/AutoComplete";
import DatePickerUi from "../../../components/form/DatePickerUi";
import FormatMoney from "../../../components/form/FormatMoney";
import validator from "./validator";
import SaveIcon from '@mui/icons-material/Save';
import HistoryIcon from '@mui/icons-material/History';
import LogsModal from "./LogsModal";
import { getLog } from "../../../store/config/thunk/log/getAll";

import { getFuelId } from "../../../store/masters/thunk/fuel/getId";
import { postFuel } from "../../../store/masters/thunk/fuel/post";
import { putFuel } from "../../../store/masters/thunk/fuel/put";
import { useCanView } from "../../../config/hook/UserPermissions";

const NewEdit = ({ setBtns }) => {
  const formikRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [__] = useTranslation("fuel");
  const [searchParams] = useSearchParams();
  const { id } = useParams();
  const [showNoti, setShowNoti] = useState({
    open: false,
    msg: "",
    variant: "error",
    action: "post",
  });
  const [alert, setAlert] = useState({
    open: false,
    title: "",
    subtitle: "",
    type: "",
  });
  const [openModal, setOpenModal] = useState(false);
  const [isMount, setIsMount] = useState(false);
  const canView = useCanView();

  const current = useSelector((state) => state.masters.fuel.detail);
  const fuel = useSelector((state) => state.masters.fuel);
  const put = useSelector((state) => state.masters.fuel.put);
  const post = useSelector((state) => state.masters.fuel.post);
  const user = useSelector(state => state.auth.login.dataUser);

  const transportFuelType = __(`transportFuelType`, { returnObjects: true });

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" });
  };

  const setError = (err, action) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (
          <ul>
            {map(get(err, "ValidationError", []), (item) => (
              <li>{`• ${item}`}</li>
            ))}
          </ul>
        ),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert,
      });
    } else {
      setAlert({
        open: true,
        type: "default",
        btn: __(`${module}.actions.close`),
        func: closeAlert,
      });
    }
  };

  useEffect(() => {
    if (get(put, "isSuccess", false)) {
      setShowNoti({ open: true, msg: "", variant: "success", action: "put" });
    }
    if (get(put, "isReject", false)) {
      setError(get(put, "error", {}), "put");
    }
    if (get(post, "isSuccess", false)) {
      setShowNoti({ open: true, msg: "", variant: "success", action: "post" });
    }
    if (get(post, "isReject", false)) {
      setError(get(post, "error", {}), "post");
    }
  }, [post, put]);

  useEffect(() => {
    if (searchParams.get("from") !== "new") {
      if (!!id) {
        let Screen = "COMBUSTIBLE"
        dispatch(getLog({page: 1, docId: Number(id), screen: String(Screen)}))
        dispatch(getFuelId({ id }));
      }
    }
  }, [dispatch, id, searchParams.get("from")]);

  const onSubmit = (values) => {

    if (canView("MAESTROS/COMBUSTIBLES", "update")) {
      const idFuel = Number(id);
  
      const body = {
          ...values,
          idFuel: idFuel,
          fuelType: get(values, "fuelType", ""), 
          startDate: get(values, "startDate", ""), 
          endDate: get(values, "endDate", ""), 
          price: get(values, "priceFuel", "")
    }
         dispatch(putFuel(body));
    } else {
      setAlert({
        open: true,
        title: "Permiso Denegado.",
        subtitle: (<ul> • No tienes permiso para actualizar el combustible.</ul>),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    }
  };

  const initialValues = {
    fuelType: id ? get(current, "data.fuelType", "") : "",
    startDate: id ? get(current, "data.startDate", "") : "",
    endDate: id ? get(current, "data.endDate", "") : "",
    priceFuel: id ? get(current, "data.price", "") : ""
  };

  useEffect(() => {
    setBtns(
      <Stack className="mr-6" direction="row" spacing={2} justifyContent="flex-end">
        <Button
          className="w-[150px] min-w-[150px]"
          variant="outlined"
          color="secondary"
          startIcon={< HistoryIcon/>}
          onClick={() => {
            if (canView("MAESTROS/COMBUSTIBLE/LOGS", "watch")) {
              setOpenModal(true)
            } else {
              setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para ver las modificaciones en combustibles.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
              })
            }
          }}
          // disabled={get(put, "isLoading")}
        >
         Ver Cambios
        </Button>
        <LoadingButton className='w-[100px] min-w-[100px]' variant="contained" color="secondary" startIcon={<SaveIcon/>} type="submit" form="form-fuel" loading={get(put, "isLoading")}>{__(`action.save`)}</LoadingButton>
        <Button className="w-[100px] min-w-[100px]" variant="outlined"  color="secondary" onClick={() => navigate("/masters/fuels/")} disabled={get(put, "isLoading")}>
          {__(`action.cancel`)}
        </Button>
      </Stack>
    );
  }, [get(put, "isLoading")]);

  return (
    <div>
      {get(current, "isLoading") ? (
        <Skeleton />
      ) : (
            <Formik innerRef={formikRef} initialValues={initialValues}
             validationSchema={validator(__)} 
             onSubmit={onSubmit}>
            {formik => (
                <form id="form-fuel" onSubmit={get(formik, "handleSubmit")}>
                    <Paper className='mt-4'>
                        <Stack className='p-4' direction="row" spacing={2} justifyContent="space-between">
                            <Typography component="h4" variant="h4">{__(`labels.1`)}</Typography>
                        </Stack>
                        <Divider />
                        <Box className='p-4' >
                            <Grid container spacing={{ xs: 2, md: 3 }}>
                              <Grid item xs={12} sm={6}>
                                  <Autocomplete
                                      name={"fuelType"}
                                      formik={formik}
                                      label={__(`form.fuelType.label`)}
                                      placeholder={__(`form.fuelType.placeholder`)}
                                      disabled={get(post, "isLoading", false)}
                                      options={transportFuelType}
                                      loading={get(fuel, "isLoading")}
                                  />
                              </Grid>
                              <Grid item xs={12} sm={6} >
                                  <InputText
                                      formik={formik}
                                      name="priceFuel"
                                      label={__(`form.priceFuel.label`)}
                                      placeholder={__(`form.priceFuel.placeholder`)}
                                      disabled={get(post, "isLoading", false)}
                                      InputProps={{
                                          inputComponent: FormatMoney,
                                      }}
                                  />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                  <DatePickerUi
                                      formik={formik}
                                      name="startDate"
                                      label={__(`form.startDate.label`)}
                                      placeholder={__(`form.startDate.placeholder`)}
                                      disabled={get(post, "isLoading", false)}
                                  />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                  <DatePickerUi
                                      formik={formik}
                                      name="endDate"
                                      label={__(`form.endDate.label`)}
                                      placeholder={__(`form.endDate.placeholder`)}
                                      disabled={get(post, "isLoading", false)}
                                  />
                              </Grid>
                            </Grid>
                        </Box>
                    </Paper>
                </form>
            )}
        </Formik>
      )}
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <LogsModal
        __={__}
        open={openModal}
        close={() => setOpenModal(false)}
      />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
    </div>
  );
};

export default NewEdit;
